import script from "./Works.vue?vue&type=script&setup=true&lang=js"
export * from "./Works.vue?vue&type=script&setup=true&lang=js"

import "./Works.vue?vue&type=style&index=0&id=cefc2830&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cefc2830"]])

export default __exports__